var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Input from '@mui/material/Input';
import LoadingButton from '@mui/lab/LoadingButton';
import SearchIcon from '@mui/icons-material/Search';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import { Delimiter } from '../../atoms/Delimiter';
import * as api from '../../../api';
import { EButtonTypes } from '../../../types';
import { TableBodyCellModal } from '../../atoms/Table/TableBodyCell';
import { useErrorHandler } from '../../../hooks/useErrorHandler';
import { Alerts } from '../../molecules/Alerts/Alerts';
const commonModalStyles = {
    padding: '30px',
    maxWidth: '668px',
    maxHeight: 'calc(100vh - 200px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
};
const commonInputStyle = {
    marginRight: '5px',
    color: '#fff',
};
const TableCellFirstGameBody = styled(TableBodyCellModal) `
  min-width: 120px;
  width: 120px;
  height: 30px;
`;
const SelectInfoWrapper = styled.div `
  display: flex;
  padding: 0;
  align-self: center;
`;
const SelectInfoText = styled.div `
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.8);
`;
const SelectInfo = styled.div `
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #000;
`;
export function AddPlayers({ matchId, setPlayersChanged, onClose }) {
    const [players, setPlayers] = useState([]);
    const [selectedPlayers, setSelectedPlayers] = useState([]);
    const { errorHandler, setSuccess } = useErrorHandler();
    const initialSearchValues = {
        real_name: '',
        game_name: '',
        matchId: matchId || '',
        first_game: '',
        last_game: '',
    };
    const searchPlayer = (data) => __awaiter(this, void 0, void 0, function* () {
        try {
            const result = yield api.searchPlayers(data);
            // console.log('AddPlayersToMatch searchPlayers', result)
            setPlayers(result);
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.log('AddPlayersToMatch searchPlayers error', e);
            errorHandler(e);
        }
    });
    useEffect(() => {
        searchPlayer(initialSearchValues);
    }, []);
    const onSearchSubmit = (data) => {
        // console.log('AddPlayers onSearchSubmit', data)
        searchPlayer(data);
    };
    const addPlayer = (playerId) => __awaiter(this, void 0, void 0, function* () {
        try {
            // console.log('AddPlayersToMatch addPlayer', playerId, matchId)
            yield api.addPlayerToMatch({ playerId, matchId: matchId || '' });
            setSuccess('Игрок успешно добавлен в игру');
            // nav(-1)
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error('AddPlayersToMatch addPlayer error', e.response);
            errorHandler(e);
        }
    });
    const addBulkPlayers = () => __awaiter(this, void 0, void 0, function* () {
        try {
            // console.log('AddPlayersToMatch addPlayer', playerId, matchId)
            yield api.addPlayersToMatch({ matchId, data: selectedPlayers });
            setSuccess('Игрок успешно добавлен в игру');
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error('AddPlayersToMatch addPlayer error', e.response);
            errorHandler(e);
        }
    });
    const onPlayerClick = (playerId) => {
        const index = selectedPlayers.indexOf(playerId);
        if (index >= 0) {
            selectedPlayers.splice(index, 1);
            setSelectedPlayers([...selectedPlayers]);
        }
        else {
            setSelectedPlayers([...selectedPlayers, playerId]);
        }
    };
    const onSaveClick = () => __awaiter(this, void 0, void 0, function* () {
        // console.log('Addplayers onSaveClick', selectedPlayers)
        // for(let playerId of selectedPlayers) {
        //   await addPlayer(playerId)
        // }
        yield addBulkPlayers();
        setPlayersChanged(true);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    });
    return (_jsxs(_Fragment, { children: [_jsx(Alerts, {}), _jsxs(Box, Object.assign({ sx: commonModalStyles }, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0438\u0433\u0440\u043E\u043A\u043E\u0432" })), _jsx(Delimiter, { top: "10px" }), _jsx(Typography, Object.assign({ variant: "subtitle1" }, { children: "\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u043E\u0434\u043D\u043E \u0438\u043B\u0438 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u043F\u043E\u043B\u0435\u0439 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0434\u0435\u0442\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u043E\u0438\u0441\u043A\u0430" })), _jsx(Delimiter, { top: "26px" }), _jsx(Formik, Object.assign({ initialValues: initialSearchValues, onSubmit: onSearchSubmit }, { children: ({ values, setFieldValue }) => (_jsxs(Form, { children: [_jsx(Input, { sx: commonInputStyle, onChange: (event) => setFieldValue('real_name', event.target.value), value: values.real_name, id: "real_name", name: "real_name", placeholder: "\u0418\u043C\u044F", type: "text" }), _jsx(Input, { sx: commonInputStyle, onChange: (event) => setFieldValue('game_name', event.target.value), value: values.game_name, id: "game_name", name: "game_name", placeholder: "\u0418\u0433\u0440\u043E\u0432\u043E\u0439 \u043D\u0438\u043A", type: "text" }), _jsx(Input, { sx: commonInputStyle, onChange: (event) => setFieldValue('first_game', event.target.value), value: values.first_game, id: "first_game", name: "first_game", placeholder: "\u041F\u0435\u0440\u0432\u0430\u044F \u0438\u0433\u0440\u0430", type: "text" }), _jsx(Input, { sx: commonInputStyle, onChange: (event) => setFieldValue('last_game', event.target.value), value: values.last_game, id: "last_game", name: "last_game", placeholder: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u044F\u044F \u0438\u0433\u0440\u0430", type: "text" }), _jsx(Delimiter, { top: "10px" }), _jsx(LoadingButton, { startIcon: _jsx(SearchIcon, {}), type: EButtonTypes.SUBMIT })] })) })), _jsx(Delimiter, { top: "26px" }), _jsx(TableContainer, Object.assign({ sx: { overflow: 'auto' } }, { children: _jsxs(Table, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0418\u043C\u044F" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0418\u0433\u0440\u043E\u0432\u043E\u0439 \u043D\u0438\u043A" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u041A\u043B\u0443\u0431" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0414\u0430\u0442\u0430 \u043F\u0435\u0440\u0432\u043E\u0439 \u0438\u0433\u0440\u044B" }))] }) }), _jsx(TableBody, Object.assign({ sx: { maxWidth: '608' } }, { children: players.map((player) => {
                                        var _a;
                                        return (_jsxs(TableRow, Object.assign({ hover: true, onClick: () => onPlayerClick(player.id), selected: selectedPlayers.includes(player.id) }, { children: [_jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: player.realName })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: player.gameName })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: ((_a = player.club) === null || _a === void 0 ? void 0 : _a.city) || '' })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: _jsx(TableCellFirstGameBody, {}) }))] }), player.id));
                                    }) }))] }) })), _jsx(Delimiter, { top: "10px" }), _jsxs(SelectInfoWrapper, { children: [_jsx(Typography, Object.assign({ variant: "subtitle1" }, { children: "\u0412\u0441\u0435\u0433\u043E \u0432\u044B\u0431\u0440\u0430\u043D\u043E \u0438\u0433\u0440\u043E\u043A\u043E\u0432:" })), _jsx(Delimiter, { right: "10px" }), _jsx(Typography, Object.assign({ variant: "subtitle1" }, { children: selectedPlayers.length }))] }), _jsx(Delimiter, { top: "10px" }), _jsx(Button, Object.assign({ sx: { width: 200, alignSelf: 'center' }, variant: "contained", onClick: () => onSaveClick() }, { children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432" }))] }))] }));
}
